/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Stack, Typography, Chip } from '@mui/material';
import styled from '@emotion/styled';
import FilterByType from './FilterByType';
import FilterByDate from './FilterByDate';
import FilterBySorting from './FilterBySorting';

const SFilterChip = styled(Chip)(() => ({
  color: '#919eab',
  margin: '0px',
  paddingLeft: '0.5rem',
  paddingRight: '0px',
}));

const ActivityFilter = ({
  types,
  values: { selectedType, selectedFromDate, selectedToDate, sortBy },
  selectedTypeChange,
  setSelectedFromDate,
  setSelectedToDate,
  setSortBy,
}) => {
  const removeTypeFilter = (option) => {
    const newSelectedType = [...selectedType];
    const index = newSelectedType.findIndex(
      (value) => value.key === option.key
    );
    newSelectedType.splice(index, 1);
    selectedTypeChange(newSelectedType);
  };

  const removeDateFilter = () => {
    setSelectedFromDate(null);
    setSelectedToDate(null);
  };

  const clearAllFilter = () => {
    selectedTypeChange([]);
    setSelectedFromDate(null);
    setSelectedToDate(null);
  };

  return (
    <Stack sx={{ width: '100%', py: 1.25 }} gap={0.625}>
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1.25}>
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.625}>
          <Typography variant="body2">Filter by</Typography>
          <FilterByType
            types={types}
            selectedType={selectedType}
            selectedTypeChange={selectedTypeChange}
          />
          <FilterByDate
            selectedFromDate={selectedFromDate}
            selectedToDate={selectedToDate}
            setSelectedFromDate={setSelectedFromDate}
            setSelectedToDate={setSelectedToDate}
          />
          {(selectedType.length || selectedFromDate || selectedToDate) && (
            <Chip
              label="Clear all"
              size="medium"
              sx={{ bgcolor: 'inherit', color: '#919eab' }}
              onDelete={() => clearAllFilter()}
            />
          )}
        </Stack>
        <Stack
          direction="row"
          sx={{ ml: { xs: 0, sm: 'auto' }, alignItems: 'center', gap: 0.625 }}
        >
          <Typography component="label" htmlFor="AccountActivitySort" variant="body2">
            Sort by
          </Typography>
          <FilterBySorting setSortBy={setSortBy} sortBy={sortBy} />
        </Stack>
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap={0.625}>
        {/* Type Filter clear Functionality */}
        {selectedType &&
          selectedType.map((option) => (
            <SFilterChip
              key={option.key}
              id={option.id}
              size="medium"
              variant="outlined"
              label={option.label}
              onDelete={() => removeTypeFilter(option)}
            />
          ))}
        {selectedFromDate && selectedToDate && (
          <SFilterChip
            id="daterange"
            size="medium"
            variant="outlined"
            label={`(${selectedFromDate}) - (${selectedToDate})`}
            onDelete={() => removeDateFilter()}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default ActivityFilter;
